import { connect } from 'react-redux'
import Billings from './Billings'

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps
  }
}

const mapDispatchToProps = dispatch => ({
})

const BillingsContainer = connect(mapStateToProps, mapDispatchToProps)(Billings)

export default BillingsContainer



// WEBPACK FOOTER //
// src/routes/Billings/BillingsContainer.js